import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { adminApi, type SyncArticle } from '@/api';
import { SyncPreview } from './SyncPreview';

export function SyncPreviewPage() {
  const { id } = useParams<'id'>();
  const [article, setArticle] = useState<SyncArticle | null>(null);
  const [loading, setLoading] = useState(true);
  const [readerMode, setReaderMode] = useState(false);

  useEffect(() => {
    if (!id) return;
    adminApi.syncArticles.get(id)
      .then(setArticle)
      .catch(() => setArticle(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="text-slate-500">Loading…</div>;
  if (!article) return <div className="text-red-600">Article not found</div>;

  const cards = (article.summaryCards ?? []).map((c) => {
    const card = c as { sub_title?: string; subTitle?: string };
    return { ...c, sub_title: card.sub_title ?? card.subTitle ?? c.sub_title ?? '' };
  }).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <Link to="/syncs" className="text-slate-600 hover:text-slate-900 text-sm">← Syncs</Link>
        <div className="flex items-center gap-4">
          <Link
            to={`/syncs/${id}/edit`}
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Edit
          </Link>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={readerMode}
              onChange={(e) => setReaderMode(e.target.checked)}
            />
            Reader mode (card-by-card)
          </label>
        </div>
      </div>
      <h1 className="text-xl font-semibold text-slate-800">Preview: {article.articleTitle}</h1>
      <SyncPreview
        articleTitle={article.articleTitle}
        sourceUrl={article.sourceUrl}
        sourceName={article.articleSource?.name}
        thumbnailUrl={article.thumbnailUrl}
        publishedAt={article.publishedAt}
        summaryCards={cards}
        readerMode={readerMode}
      />
    </div>
  );
}
